// src/api/adminAuthApi.js
import { adminJson } from "./adminHttp";

export async function adminLogin(email, password) {
  return adminJson("/admin/auth/login", {
    method: "POST",
    json: { email, password },
  });
}

export async function adminMeApi() {
  return adminJson("/admin/auth/me", {
    method: "GET",
  });
}